export const STICKY_COLORS = {
  yellow: { light: '#FEF3C7', dark: '#78350f' },
  green: { light: '#D1FAE5', dark: '#14532d' },
  blue: { light: '#DBEAFE', dark: '#1e3a8a' },
  pink: { light: '#FCE7F3', dark: '#831843' },
  purple: { light: '#EDE9FE', dark: '#581c87' },
  orange: { light: '#FED7AA', dark: '#9a3412' },
  red: { light: '#FEE2E2', dark: '#7f1d1d' },
  indigo: { light: '#E0E7FF', dark: '#3730a3' },
  teal: { light: '#CCFBF1', dark: '#134e4a' },
  cyan: { light: '#CFFAFE', dark: '#155e75' },
  lime: { light: '#ECFCCB', dark: '#365314' },
  emerald: { light: '#D1FAE5', dark: '#064e3b' },
  gray: { light: '#F3F4F6', dark: '#374151' },
  slate: { light: '#F1F5F9', dark: '#334155' },
  amber: { light: '#FEF3C7', dark: '#78350f' },
  rose: { light: '#FFE4E6', dark: '#881337' },
} as const

export const STICKY_MIN_WIDTH = 150
export const STICKY_MAX_WIDTH = 600
export const STICKY_MIN_HEIGHT = 100
export const STICKY_MAX_HEIGHT = 400
